import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Always send cookies on cross-origin/same-origin requests so the referral cookie
// (jsf_ref) flows back to the backend on subsequent calls (order creation, etc.).
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
